let cachedDictionary = null
let cachedDictionaryResult = null

/**
 * Transform the dictionary data into a more usable format.
 * Function is memoized to avoid recomputation on same dictionary reference.
 */
export function transformDictionary(dictionary) {
  if (!dictionary) {
    return null
  }

  if (dictionary === cachedDictionary) {
    return cachedDictionaryResult
  }

  cachedDictionary = dictionary
  cachedDictionaryResult = Object.fromEntries(
    dictionary
      .filter((kv) => kv?.key && kv?.value)
      .map((kv) => [kv.key, kv.value])
  )

  return cachedDictionaryResult
}
